import { KText } from '@/ui-library/components';
import React from 'react';

// Utility for rendering errors inside a <FormErrorMessage>.
export function renderErrors(label, errors) {
  if (errors) {
    if (Array.isArray(errors)) {
      return errors.map((err, idx) => (
        <KText color="error-200" key={idx}>
          {label} {err}
        </KText>
      ));
    }
    return (
      <KText color="error-200">
        {label} {errors}
      </KText>
    );
  }
}
